<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addIndexPoster">
          {{ $t('ADD' || '添加') }}
        </a-button>
      </div>
      <a-row :gutter="16">
        <a-col
          :span="4"
          v-for="item in table.data"
          :key="item.id">
          <!-- hoverable 可以浮动 -->
          <a-card
            style="margin-bottom: 20px"
            hoverable>
            <img
              slot="cover"
              alt="example"
              class="cover-img"
              :src="item.coverPath"/>
            <template slot="actions" class="ant-card-actions">
              <a-icon type="edit" @click="editIndexPoster(item.id)"/>
              <a-icon type="link" @click="editIndexPosterJump(item.id)"/>
              <a-icon type="close" @click="deleteIndexPoster(item.id)"/>
              <a-icon type="left" @click="upIndexPoster(item.id)"/>
              <a-icon type="right" @click="downIndexPoster(item.id)"/>
            </template>
            <!--          <a-card-meta-->
            <!--          :title="item.name"-->
            <!--          :description="item.subTitle.length > 10-->
            <!--            ? item.subTitle.slice(0,10) + '...' : item.subTitle">-->
            <!--          </a-card-meta>-->
            <a-card-meta :title="item.name" :description="item.subTitle">
            </a-card-meta>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <a-modal
      :footer="null"
      title="首页海报跳转编辑"
      v-model="jumpForm.visible">
      <index-poster-jump-edit
        v-if="jumpForm.visible"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm"
        :index-poster-id="jumpForm.data.id"/>
    </a-modal>
    <a-modal
      :footer="null"
      title="首页海报编辑"
      v-model="form.visible">
      <index-poster-edit
        v-if="form.visible"
        :index-poster-id="form.data.id"
        :on-submit-handler="closeForm"
        :on-cancel-handler="closeForm">
      </index-poster-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryIndexPosters,
  _deleteIndexPoster,
  _upIndexPoster,
  _downIndexPoster,
} from '@/api/indexPosterApi';
import IndexPosterEdit from './IndexPosterEdit.vue';
import IndexPosterJumpEdit from './IndexPosterJumpEdit.vue';

async function getIndexPosterList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryIndexPosters({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
}

function addIndexPoster() {
  this.form.data.id = null;
  this.form.visible = true;
}
function editIndexPoster(indexPosterId) {
  this.form.data.id = indexPosterId;
  this.form.visible = true;
}

function editIndexPosterJump(indexPosterId) {
  this.jumpForm.data.id = indexPosterId;
  this.jumpForm.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.jumpForm.data.id = null;
  this.jumpForm.visible = false;
  this.getIndexPosterList();
}

async function deleteIndexPoster(indexPosterId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteIndexPoster(indexPosterId);
      this.$message.success('删除成功');
      this.getIndexPosterList();
    },
  });
}

async function upIndexPoster(indexPosterId) {
  this.$confirm({
    title: '是否上移？',
    content: '',
    onOk: async () => {
      await _upIndexPoster(indexPosterId);
      this.$message.success('上移成功');
      this.getIndexPosterList();
    },
  });
}

async function downIndexPoster(indexPosterId) {
  this.$confirm({
    title: '是否下移？',
    content: '',
    onOk: async () => {
      await _downIndexPoster(indexPosterId);
      this.$message.success('下移成功');
      this.getIndexPosterList();
    },
  });
}

export default {
  name: 'IndexPosterList',
  components: { IndexPosterJumpEdit, IndexPosterEdit },
  props: {},
  data() {
    return {
      jumpForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getIndexPosterList,
    deleteIndexPoster,
    editIndexPoster,
    editIndexPosterJump,
    addIndexPoster,
    closeForm,
    upIndexPoster,
    downIndexPoster,
  },
  created() {
    this.getIndexPosterList();
  },
};
</script>

<style scoped>
.cover-img {
  border-radius: 2px 2px 0 0;
  height: 300px;
  object-fit: cover;
  object-position: top;
}

</style>
